export default __webpack_public_path__ + "static/media/transfer.2255565f.svg";